var lib_core           = require("lib-core");
var Properties = require("cio-config").MetaProperties;
var _        = require('underscore');

var FootprintSettingsView = function(model, stateMachine, parentView, config) {
    ui_extensions.SettingsView.apply(this, arguments);

    var form = this.getTemplate();
    var self = this;

    for(var key in Properties["footprint"]){
        if(Properties["footprint"].hasOwnProperty(key)){
            var info = Properties["footprint"][key];
            createView(info.displayTitle, this.model[key], info.defaultText, config.propertiesReadOnly, info.description, false, info.unit, info.enums);
        }
    }

    function createView(name, shadow, defaultText, isReadOnly, explanation, ignoreFocus, unit, enums){
        var name = form.addFormElement(name);
        if(!enums){
            var field = name.addTextInput(shadow(), defaultText, isReadOnly);
        } else {
            var field = name.addSelectBox(shadow(), getSelectBoxOptionsFromEnums(enums), isReadOnly);
            ignoreFocus = true;
        }
        self.addInteraction(field, shadow, 'Cioui:Form:value', ignoreFocus, unit);
        if(explanation) name.addSubhead(explanation);
    }

    function getSelectBoxOptionsFromEnums( enums ){
        var options = [];
        options.push({
            name: "Select One",
            value: NaN
        });
        _.each(enums, function(currEnum){ 
            options.push({
                name: currEnum.key,
                value: currEnum.val
            });
        });
        return options;
    }

};

if(typeof window !== 'undefined') {
    var ui_extensions = require("ui-extensions");
    lib_core.inherit(FootprintSettingsView, ui_extensions.SettingsView);
}
module.exports = FootprintSettingsView;
